export default "__VITE_ASSET__DDYfPigU__"